export default "__VITE_ASSET__BeIY0IEv__"